import {Dialog, SnackbarService, String} from "@hps/hops-react";
import {SeatReservationUtils} from "@hps/hops-sdk-js";
import Divider from "@mui/material/Divider";
import {useCallback, useMemo} from "react";
import {useSelector} from "react-redux";

import dSeatReservationDialog from "Dispatchers/dSeatReservationDialog.js";
import useCheckoutBasket from "Hooks/useCheckoutBasket.js";
import useStrings from "Hooks/useStrings.js";

import SeatReservationHandler from "./SeatReservationHandler.js";

import scss from "./SeatReservationDialog.module.scss";

const SeatReservationDialog = () => {

	const {checkoutBasket, checkoutBasketId, checkoutBasketLoading} = useCheckoutBasket();
	const {seatReservationDialog: targetBasketItemUuid} = useSelector(store => store);
	const strings = useStrings();


	/**
	 * Basket item we're rendering for
	 */
	const targetBasketItem = useMemo(() => checkoutBasket.find(({Uuid}) => (Uuid === targetBasketItemUuid)), [checkoutBasket, targetBasketItemUuid]);


	/**
	 * Dialog closed.
	 * 
	 * @return {void}
	 */
	const handleClose = useCallback(() => {
		dSeatReservationDialog(null);
	}, []);


	/**
	 * Submit handler.
	 *
	 * @return {void}
	 */
	const handleSubmit = useCallback(() => {
		if (SeatReservationUtils.validateBasketItemSelection(targetBasketItem, checkoutBasket)) {
			handleClose();
		}
		else SnackbarService.snack("Please complete the selection.", "error");
	}, [handleClose, checkoutBasket, targetBasketItem]);


	/**
	 * Render!
	 */
	return (
		<Dialog
			classNameActions={scss.actions}
			classNamePaper={scss.root}
			disableImplicitClose={true}
			invertActionButtons={true}
			loading={checkoutBasketLoading}
			open={!!targetBasketItem}
			onClose={handleClose}
			onOk={handleSubmit}
			title="Seat Reservation"
			width="lg">
			<String
				color="textSecondary"
				gap={0.75}
				str={strings.checkoutSeatReservation} />
			<Divider />
			<SeatReservationHandler
				basket={checkoutBasket}
				basketLoading={checkoutBasketLoading}
				targetBasketId={checkoutBasketId}
				targetBasketItem={targetBasketItem} />
		</Dialog>
	);

};

export default SeatReservationDialog;
